import { render, staticRenderFns } from "./addPacks.vue?vue&type=template&id=5ff03af4&scoped=true&"
import script from "./addPacks.vue?vue&type=script&lang=js&"
export * from "./addPacks.vue?vue&type=script&lang=js&"
import style0 from "./addPacks.vue?vue&type=style&index=0&id=5ff03af4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff03af4",
  null
  
)

export default component.exports